export default {
  methods: {
    // 处理后台数据
    transResData(data, num) {
      const xNames = []
      const y1Names = []
      const y2Names = []
      if (data) {
        for (const item of data) {
          xNames.push(item.xname)
          y1Names.push(item.y1Name)
          if (num === 2) {
            y2Names.push(item.y2Name)
          }
        }
      }
      return { xNames, y1Names, y2Names }
    },
    createOption(params) {
      const option = {
        tooltip: {},
        grid: params.grid ? params.grid : { right: 0, left: '8%' },
        color: params.color ? params.color : ['#43d4d4', '#f7ba1f'],
        xAxis: [
          {
            type: 'category',
            data: params.xNames
          }
        ],
        yAxis: {},
        series: params.series
      }
      if (params.legend) {
        option.legend = params.legend
      }
      if (params.title) {
        option.title = params.title
      }
      return option
    }
  }
}
